export const STAND_CUSTOMER_ID = 114964;
export const DIST_CHART_LARGE_NUM_BARS = 100;
export const DIST_CHART_NUM_SHOW_LABELS = 12;
export const INITIAL_SCHOOLS_TABLE_PAGE_SIZE = 100;
export const STUDENT_EXPORT_LIMIT = 25000;
export const FRECKLE_ACTIVE_METRIC_IDS = [673, 675, 677, 679];
export const FRECKLE_ACCURACY_METRIC_IDS = [681, 683, 685, 687];
export const FRECKLE_METRIC_IDS = [
  ...FRECKLE_ACTIVE_METRIC_IDS,
  ...FRECKLE_ACCURACY_METRIC_IDS,
];
export const TIERS = {
  STARTER: {
    key: "starter",
    value: "Starter",
  },
  PROFESSIONAL: {
    key: "professional",
    value: "Professional",
  },
};

export const HELP_URLS = {
  HELP_CENTER_NONSTARTER_URL: "https://help2.renaissance.com/schoolzilla",
  HELP_CENTER_STARTER_URL: "https://help2.renaissance.com/schoolzilla-starter",
  DATA_CONFIGURATION_NONSTARTER_URL:
    "https://help2.renaissance.com/schoolzilla/DataConfigurationSettingsVideo",
  DATA_CONFIGURATION_STARTER_URL:
    "https://help2.renaissance.com/schoolzilla-starter/DataConfigurationSettings",
  GRADUATION_CREDITS_NONSTARTER_URL:
    "https://help2.renaissance.com/schoolzilla/CreditsEarnedTowardGraduation",
};

export const GROUP_STATUS_CONST = "Group Status";
export const OOPS_MESSAGES = {
  ACCESS_CONTENT_VIEW:
    "Oops! You do not have permission to access content for this view.",
  RENDER_VIEW: "Oops, we're unable to render this view. Please try again later",
  ACCESS_CONTENT: "Oops! You do not have permission to access this content.",
  RENDER_DASHBOARD:
    "Oops, we're unable to render this dashboard. Please try again later",
  RETRIEVE_METRICS_FOR_SCHOOL:
    "Oops, we're unable to retrieve metrics for this school. Please try again later",
};
